import { render, staticRenderFns } from "./NewCalendar.vue?vue&type=template&id=9163b55a&scoped=true"
import script from "./NewCalendar.vue?vue&type=script&lang=js"
export * from "./NewCalendar.vue?vue&type=script&lang=js"
import style0 from "./NewCalendar.vue?vue&type=style&index=0&id=9163b55a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163b55a",
  null
  
)

export default component.exports